<template>
  <section>
    <router-view :key="key" />
  </section>
</template>
<script>
export default {
  components: {
  },
  props: {},
  data () {
    return {}
  },
  watch: {},
  computed: {
    key() {
      return this.$route.path
    }
  },
  methods: {},
  created () {},
  mounted () {}
}
</script>